import { render, staticRenderFns } from "./commissionRuleGroup.vue?vue&type=template&id=35fd798e&scoped=true"
import script from "./commissionRuleGroup.vue?vue&type=script&lang=js"
export * from "./commissionRuleGroup.vue?vue&type=script&lang=js"
import style0 from "./commissionRuleGroup.vue?vue&type=style&index=0&id=35fd798e&prod&lang=scss&scoped=true"
import style1 from "./commissionRuleGroup.vue?vue&type=style&index=1&id=35fd798e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd798e",
  null
  
)

export default component.exports